<template>
  <div class="modal-bot-notifications">
    <Dialog
      :header="modalBotTitle"
      :visible.sync="$parent.showBotModal"
      @update:visible="toggleBotModal"
      :modal="true"
      :baseZIndex="11050"
      :dismissableMask="true"
      :draggable="false"
      :resizable="false"
      :containerStyle="$isMobile ? mobileStyle : desktopStyle"
      :position="$isMobile ? 'center' : 'right'"
      @hide="onHideBotModal()"
    >
      <template #header>
        <div class="bot-modal-header">
          <div class="header-content">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="width: 22px; height: 22px"
            >
              <path fill="currentColor" d="M20.006 15.344a.544.544 0 0 0-1.012 0l-.946 2.398a.54.54 0 0 1-.306.306l-2.398.946a.544.544 0 0 0 0 1.012l2.398.946c.14.055.251.166.306.306l.946 2.398c.181.459.83.459 1.012 0l.946-2.398a.54.54 0 0 1 .306-.306l2.398-.946a.544.544 0 0 0 0-1.012l-2.398-.946a.54.54 0 0 1-.306-.306z" />
              <path fill="currentColor" d="M12 .125a1 1 0 0 1 1 1v2.48c0 .112 0 .169.029.208q.014.02.033.033c.04.029.096.029.208.029h.005c1.665 0 2.994-.001 4.052.113 1.077.117 1.99.364 2.78.938a5.5 5.5 0 0 1 1.217 1.217c.574.79.821 1.703.938 2.78.114 1.058.113 2.387.113 4.052v.3q0 .661-.002 1.253c-.003.441-.004.662-.087.703a.15.15 0 0 1-.08.015c-.092-.009-.175-.218-.34-.636l-.085-.195a2.47 2.47 0 0 0-1.243-1.2c-.066-.03-.1-.044-.12-.064a.14.14 0 0 1-.032-.05c-.011-.026-.011-.06-.011-.126 0-1.71-.001-2.911-.102-3.836-.098-.907-.28-1.429-.566-1.822a3.5 3.5 0 0 0-.774-.774c-.393-.285-.915-.468-1.822-.566-.925-.1-2.126-.102-3.836-.102h-2.55c-1.71 0-2.911.001-3.836.102-.907.098-1.43.28-1.822.566a3.5 3.5 0 0 0-.774.774c-.285.393-.468.915-.566 1.822-.1.925-.102 2.126-.102 3.836v.3c0 1.71.001 2.911.102 3.836.098.907.28 1.43.566 1.822a3.5 3.5 0 0 0 .774.774c.393.285.915.468 1.822.566.925.1 2.126.102 3.836.102h2.236c.08 0 .12 0 .152.016q.015.006.029.019c.027.022.045.062.08.142.25.564.713 1.048 1.388 1.314.418.165.627.248.636.34a.15.15 0 0 1-.015.08c-.041.083-.262.084-.703.087q-.592.003-1.253.002h-2.55c-1.665 0-2.994.001-4.052-.113-1.077-.117-1.99-.364-2.78-.938a5.5 5.5 0 0 1-1.217-1.217c-.574-.79-.821-1.703-.938-2.78-.114-1.058-.113-2.387-.113-4.052v-.3c0-1.665-.001-2.994.113-4.052.117-1.077.364-1.99.938-2.78a5.5 5.5 0 0 1 1.217-1.217c.79-.574 1.703-.821 2.78-.938 1.058-.114 2.387-.113 4.052-.113h.005c.112 0 .169 0 .208-.029a.2.2 0 0 0 .033-.033c.029-.04.029-.096.029-.208v-2.48a1 1 0 0 1 1-1" />
              <path fill="currentColor" d="M8.25 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M15.75 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
            </svg>

            <div class="title-wrap">
              <span class="modal-title">
                {{ safeT("bot.modal.title", "Bandeja de mensajes") }}
              </span>
              <small>
                {{
                  safeT(
                    "bot.modal.subtitle",
                    "WhatsApp, Conserje web y OTA en un solo sitio"
                  )
                }}
              </small>
            </div>

            <span v-if="unreadBotCount > 0" class="header-unread">
              {{ unreadBotCount }}
              <span class="header-unread__label">sin leer</span>
            </span>
          </div>
        </div>
      </template>

      <div class="bot-notifications-content">
        <!-- Sugerencias para aprender (autoaprendizaje del Agente IA) -->
        <faq-learning-suggestions ref="learnSuggestions" class="bot-learn-suggestions" />

        <div v-if="botNotifications.length > 0" class="search-bar">
          <div class="search-input-wrapper">
            <span class="search-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="11" cy="11" r="7" />
                <line x1="16.5" y1="16.5" x2="21" y2="21" />
              </svg>
            </span>

            <input
              v-model="searchQuery"
              type="text"
              class="search-input"
              :placeholder="
                safeT(
                  'bot.search.placeholder',
                  'Buscar por nombre, teléfono o código de reserva...'
                )
              "
            />

            <button
              v-if="searchQuery"
              type="button"
              class="clear-btn"
              @click="searchQuery = ''"
            >
              ×
            </button>
          </div>

          <!-- Filtro por canal: solo aparece cuando hay conversaciones de más de un
               canal, que es cuando mezclarlos empieza a confundir. -->
          <div v-if="channelFilters.length > 2" class="channel-filters" role="tablist">
            <button
              v-for="filter in channelFilters"
              :key="filter.key"
              type="button"
              role="tab"
              class="channel-filter"
              :class="{ 'is-active': activeChannel === filter.key }"
              :aria-selected="activeChannel === filter.key ? 'true' : 'false'"
              @click="activeChannel = filter.key"
            >
              {{ filter.label }}
              <span class="channel-filter__count">{{ filter.count }}</span>
            </button>
          </div>
        </div>

        <div v-if="botNotifications.length === 0" class="empty-state">
          <div class="empty-icon">
            <svg
              width="64"
              height="64"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1"
              stroke="#cccccc"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
              />
            </svg>
          </div>
          <h4>{{ safeT("bot.empty.title", "Sin conversaciones de bot") }}</h4>
          <p>
            {{
              safeT(
                "bot.empty.description",
                "Cuando el Agente IA responda a tus huéspedes, verás las conversaciones aquí."
              )
            }}
          </p>
        </div>

        <template v-else>
          <div
            v-if="filteredNotifications.length === 0"
            class="empty-state empty-filter"
          >
            <div class="empty-icon">
              <svg
                width="48"
                height="48"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1"
                stroke="#cccccc"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3 4.5h18M6 9l4.5 4.5v6l3-2v-4L18 9"
                />
              </svg>
            </div>
            <h4>
              {{
                safeT(
                  "bot.search.noResultsTitle",
                  "No se encontraron conversaciones"
                )
              }}
            </h4>
            <p>
              {{
                safeT(
                  "bot.search.noResultsDescription",
                  "Prueba con otro nombre, teléfono o código de reserva."
                )
              }}
            </p>
          </div>

          <div v-else class="notifications-list">
            <div
              v-for="notification in filteredNotifications"
              :key="
                notification.key ||
                notification.id ||
                `${notification.phoneDigits || notification.phone_number || 'na'}|${getReservationCode(notification) || 'none'}|${notification.checkinId || notification.checkin_id || 'none'}|${notification.timestamp || notification.last_message_at || ''}`
              "
              class="chat-list-item"
              :class="{ unread: isNotificationUnread(notification) }"
              @click="onClickItem(notification)"
            >
              <div
                class="chat-avatar"
                :style="avatarStyle(displayGuestName(notification))"
              >
                <span>{{ getInitials(displayGuestName(notification)) }}</span>
                <!-- Badge de canal: WhatsApp vs Conserje web vs OTA (Booking/Airbnb…) -->
                <span
                  class="chat-channel-badge"
                  :class="`chat-channel-badge--${notificationChannel(notification)}`"
                  :title="channelLabel(notification)"
                >
                  <svg
                    v-if="notificationChannel(notification) === 'web'"
                    viewBox="0 0 24 24"
                    width="10"
                    height="10"
                    fill="currentColor"
                  >
                    <path d="M12 3C6.5 3 2 6.6 2 11c0 2.15 1.05 4.12 2.8 5.5L4 21l4.7-1.35c1.02.28 2.13.35 3.3.35 5.5 0 10-3.6 10-8s-4.5-8-10-8z" />
                  </svg>
                  <IconOTA
                    v-else-if="notificationChannel(notification) === 'ota'"
                    :channel_id="otaChannelId(notification)"
                    :styleIcon="12"
                  />
                  <img v-else src="/whatsapp.png" alt="WhatsApp" width="12" height="12" />
                </span>
              </div>

              <div class="chat-main">
                <div class="chat-top-row">
                  <div class="chat-title-block">
                    <h4 class="chat-name">
                      {{ displayGuestName(notification) }}
                    </h4>
                  </div>

                  <div class="chat-top-actions">
                    <span class="chat-time">
                      {{
                        prettyTime(
                          notification.timestamp ||
                            notification.last_message_at
                        )
                      }}
                    </span>

                    <button
                      type="button"
                      class="archive-btn"
                      @click.stop="onArchiveClick(notification)"
                      :title="
                        safeT(
                          'bot.buttons.archive',
                          'Archivar conversación'
                        )
                      "
                      v-tooltip.bottom="
                        safeT(
                          'bot.buttons.archive',
                          'Archivar conversación'
                        )
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="16"
                        height="16"
                      >
                        <path
                          d="M19.5 21a3 3 0 0 0 3-3v-4.5a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h15ZM1.5 10.146V6a3 3 0 0 1 3-3h5.379a2.25 2.25 0 0 1 1.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 0 1 3 3v1.146A4.483 4.483 0 0 0 19.5 9h-15a4.483 4.483 0 0 0-3 1.146Z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <div class="chat-bottom-row">
                  <!-- La habitación/alojamiento va aquí, delante del mensaje: en la línea
                       del nombre le robaba el sitio y ambos quedaban cortados. -->
                  <span v-if="hasProperty(notification)" class="chat-room">
                    {{ propertyLabel(notification) }}
                  </span>

                  <p class="chat-preview">
                    {{
                      truncateMessage(
                        notification.message ||
                          notification.last_message_preview
                      )
                    }}
                  </p>

                  <span
                    v-if="getNotificationUnreadCount(notification) > 0"
                    class="chat-unread-count"
                  >{{ getNotificationUnreadCount(notification) }}</span>
                  <span
                    v-else-if="isNotificationUnread(notification)"
                    class="chat-unread-dot"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <template #footer>
        <div class="bot-modal-footer">
          <Button
            :tooltip="safeT('bot.buttons.markAll', 'Marcar todas como leídas')"
            class="icon-btn outline"
            icon="pi pi-envelope-open"
            @click="markAllAsRead"
            :disabled="!hasUnreadNotifications"
            v-tooltip.bottom="
              safeT('bot.buttons.markAll', 'Marcar todas como leídas')
            "
          >
            <svg
              style="width: 20px"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
              />
            </svg>
          </Button>
        </div>
      </template>
    </Dialog>

    <transition name="modal">
      <div
        v-if="confirmArchiveVisible"
        class="modal-overlay"
        @click.self="closeArchiveDialog"
      >
        <div class="modal-container">
          <div class="modal-header">
            <h3>
              {{ safeT("bot.archive.title", "Archivar conversación") }}
            </h3>
            <button
              @click="closeArchiveDialog"
              class="btn-close"
              :disabled="archiving"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="modal-body">
            <div class="warning-box">
              <i class="fas fa-exclamation-triangle"></i>
              <div>
                <strong>
                  {{ safeT("bot.archive.title", "Archivar conversación") }}
                </strong>
                <p>
                  {{
                    safeT(
                      "bot.archive.message",
                      "Si archivas esta conversación dejará de aparecer en esta lista. Podrás seguir viéndola desde la reserva asociada."
                    )
                  }}
                </p>
              </div>
            </div>

            <p
              v-if="notificationToArchive"
              class="hint hint-guest"
            >
              <b>{{ displayGuestName(notificationToArchive) }}</b>
              <span v-if="getReservationCode(notificationToArchive)">
                · {{ getReservationCode(notificationToArchive) }}
              </span>
            </p>
          </div>

          <div class="modal-footer">
            <button
              @click="closeArchiveDialog"
              class="btn-cancel"
              :disabled="archiving"
            >
              {{ safeT("bot.archive.cancel", "Cancelar") }}
            </button>

            <button
              @click="confirmArchive"
              class="btn-save btn-danger-strong"
              :disabled="archiving"
            >
              <span v-if="archiving" class="btn-spinner"></span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                width="18"
                height="18"
              >
                <path
                  d="M19.5 21a3 3 0 0 0 3-3v-4.5a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h15ZM1.5 10.146V6a3 3 0 0 1 3-3h5.379a2.25 2.25 0 0 1 1.59.659l2.122 2.121c.14.141.331.22.53.22H19.5a3 3 0 0 1 3 3v1.146A4.483 4.483 0 0 0 19.5 9h-15a4.483 4.483 0 0 0-3 1.146Z"
                />
              </svg>
              {{
                archiving
                  ? safeT("bot.archive.processing", "Archivando...")
                  : safeT("bot.archive.confirm", "Archivar")
              }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Dialog from "primevue/dialog";
import Badge from "primevue/badge";
import Button from "primevue/button";
import Tooltip from "primevue/tooltip";
import FaqLearningSuggestions from "@/components/Propiedades/FaqLearningSuggestions.vue";
import IconOTA from "@/components/Reservas/IconOTA.vue";

export default {
  props: {
    toggleBotModal: Function,
    botNotifications: { type: Array, default: () => [] },
    hasBotNotifications: Boolean,
    markAllAsRead: Function,
    selectNotification: Function,
    archiveNotification: Function,
    property: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  components: { Dialog, Badge, Button, FaqLearningSuggestions, IconOTA },
  directives: {
    tooltip: Tooltip,
  },
  data() {
    return {
      isLargeDesktop:
        typeof window !== "undefined" ? window.innerWidth >= 1600 : false,
      searchQuery: "",
      activeChannel: "all",
      confirmArchiveVisible: false,
      notificationToArchive: null,
      archiving: false,
    };
  },
  computed: {
    hasUnreadNotifications() {
      return this.botNotifications.some((n) => this.isNotificationUnread(n));
    },
    unreadBotCount() {
      return this.botNotifications.reduce(
        (total, notification) =>
          total + this.getNotificationUnreadCount(notification),
        0
      );
    },
    modalBotTitle() {
      return this.safeT("bot.modal.title", "Agente IA ✨");
    },
    isModalOpen() {
      return !!(this.$parent && this.$parent.showBotModal);
    },
    desktopStyle() {
      // Ancho de columna de chat (tipo WhatsApp/Telegram), no un panel enorme.
      const width = this.isLargeDesktop ? "460px" : "430px";
      return {
        width,
        height: "100vh",
        textAlign: "left",
        padding: "0",
      };
    },
    mobileStyle() {
      return {
        width: "95vw",
        height: "95vh",
        textAlign: "left",
        padding: "0",
      };
    },
    // Canales presentes en la bandeja, con su recuento. Se construye a partir de los
    // datos reales: si el anfitrión solo usa WhatsApp, no le mostramos filtros vacíos.
    channelFilters() {
      const counts = { whatsapp: 0, web: 0, ota: 0 };
      this.botNotifications.forEach((n) => {
        const ch = this.notificationChannel(n);
        if (counts[ch] !== undefined) counts[ch] += 1;
      });

      const present = ["whatsapp", "web", "ota"].filter((key) => counts[key] > 0);
      if (present.length < 2) return [];

      return [
        {
          key: "all",
          label: this.safeT("bot.channels.all", "Todos"),
          count: this.botNotifications.length,
        },
        ...present.map((key) => ({
          key,
          label: this.safeT(
            `bot.channels.${key}`,
            key === "web" ? "Web" : key === "ota" ? "OTA" : "WhatsApp"
          ),
          count: counts[key],
        })),
      ];
    },

    filteredNotifications() {
      const qRaw = this.searchQuery || "";
      const q = qRaw.trim().toLowerCase();
      const qDigits = qRaw.replace(/\D/g, "");

      const byChannel =
        this.activeChannel === "all"
          ? this.botNotifications
          : this.botNotifications.filter(
              (n) => this.notificationChannel(n) === this.activeChannel
            );

      if (!q && !qDigits) {
        return byChannel;
      }

      return byChannel.filter((n) => {
        const phone = (n.phoneDigits || n.phone_number || "")
          .toString()
          .replace(/\D/g, "");
        const guestName = (n.senderName || n.guest_name || "")
          .toString()
          .toLowerCase();
        const reservationCode = (
          n.reservation_code ||
          n.reservationCode ||
          (n.raw &&
            (n.raw.reservation_code || n.raw.reservationCode)) ||
          ""
        )
          .toString()
          .toLowerCase();
        const propertyName = (
          (n.raw && n.raw.property && n.raw.property.nombre) ||
          (n.property && n.property.nombre) ||
          ""
        )
          .toString()
          .toLowerCase();

        const byName = q && guestName.includes(q);
        const byReservation = q && reservationCode.includes(q);
        const byProperty = q && propertyName.includes(q);
        const byPhone = qDigits && phone.includes(qDigits);

        return byName || byReservation || byProperty || byPhone;
      });
    },
  },
  watch: {
    // Cada vez que se abre el modal, refresca las sugerencias para aprender.
    isModalOpen(open) {
      if (open && this.$refs.learnSuggestions) {
        this.$refs.learnSuggestions.load();
      }
    },
  },
  mounted() {
    if (typeof window !== "undefined") {
      this._resizeHandler = () => {
        this.isLargeDesktop = window.innerWidth >= 1600;
      };
      window.addEventListener("resize", this._resizeHandler);
    }
  },
  beforeDestroy() {
    if (this._resizeHandler && typeof window !== "undefined") {
      window.removeEventListener("resize", this._resizeHandler);
    }
  },
  methods: {
    safeT(key, fallback) {
      try {
        const v = this.$t ? this.$t(key) : null;
        return typeof v === "string" && v.length ? v : fallback;
      } catch (e) {
        return fallback;
      }
    },
    formatPhone(d) {
      if (!d) return "No vinculado";
      const s = ("" + d).replace(/\D/g, "");
      if (s.length <= 3) return s;
      if (s.length <= 6) return `${s.slice(0, 3)} ${s.slice(3)}`;
      return `+${s.slice(0, 2)} ${s.slice(2, 5)} ${s.slice(5, 8)} ${s
        .slice(8)
        .trim()}`.trim();
    },
    prettyTime(ts) {
      if (!ts) return "";
      const d = ts instanceof Date ? ts : new Date(ts);
      if (isNaN(d.getTime())) return "";

      const now = new Date();
      const diffMs = now.getTime() - d.getTime();
      const diffMin = Math.floor(diffMs / 60000);
      const diffHour = Math.floor(diffMs / 3600000);
      const diffDay = Math.floor(diffMs / 86400000);

      // Formato COMPACTO y de ancho estable ("5 min", "3 h", "2 d", "28 jun"). El
      // anterior mezclaba "hace 24 días" con "28 jun 2026": dos gramáticas distintas
      // en la misma columna, y las cadenas largas empujaban el nombre del huésped.
      if (diffMin < 1) return this.safeT("bot.time.now", "Ahora");
      if (diffMin < 60) return `${diffMin} min`;
      if (diffHour < 24) return `${diffHour} h`;
      if (diffDay < 7) return `${diffDay} d`;

      const sameYear = d.getFullYear() === now.getFullYear();
      return d
        .toLocaleDateString("es-ES", {
          day: "numeric",
          month: "short",
          ...(sameYear ? {} : { year: "numeric" }),
        })
        .replace(".", "");
    },
    truncateMessage(message, length = 120) {
      if (!message) return "";
      let text = String(message).replace(/\s+/g, " ").trim();
      // Limpia el formato de WhatsApp para un preview legible:
      // *negrita*, _cursiva_, ~tachado~, `código`, ```bloque``` → texto plano.
      text = text
        .replace(/```([^`]+)```/g, "$1")
        .replace(/`([^`]+)`/g, "$1")
        .replace(/\*([^*\n]+)\*/g, "$1")
        .replace(/_([^_\n]+)_/g, "$1")
        .replace(/~([^~\n]+)~/g, "$1");
      return text.length <= length ? text : text.substring(0, length) + "…";
    },
    onHideBotModal() {
      this.$parent.showBotModal = false;
    },
    hasReservationCode(n) {
      return !!(
        n &&
        ((n.raw &&
          (n.raw.reservation_code || n.raw.reservationCode)) ||
          n.reservation_code ||
          n.reservationCode)
      );
    },
    getReservationCode(n) {
      if (!n) return "";
      if (n.reservation_code || n.reservationCode) {
        return n.reservation_code || n.reservationCode;
      }
      if (n.raw) {
        return n.raw.reservation_code || n.raw.reservationCode || "";
      }
      return "";
    },
    hasProperty(n) {
      return !!this.propertyLabel(n);
    },
    propertyLabel(n) {
      if (!n) return "";
      return (
        (n.raw && n.raw.property && n.raw.property.nombre) ||
        (n.property && n.property.nombre) ||
        ""
      );
    },
    displayGuestName(n) {
      if (!n) return "";
      return (
        n.senderName ||
        n.guest_name ||
        this.formatPhone(n.phoneDigits || n.phone_number)
      );
    },
    getInitials(name) {
      const safe = String(name || "").trim();
      if (!safe) return "G";
      const parts = safe.split(/\s+/).filter(Boolean);
      if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
      return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
    },
    // Color suave y estable por contacto (mismo nombre → mismo color), estilo
    // Telegram/Google. El canal (WhatsApp/web) lo indica el badge del avatar.
    avatarStyle(name) {
      const key = String(name || "?").trim() || "?";
      let h = 0;
      for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
      const palette = [
        { bg: "#dcfce7", fg: "#0a8f2d" },
        { bg: "#e0e7ff", fg: "#4338ca" },
        { bg: "#ffe4e6", fg: "#be123c" },
        { bg: "#ffedd5", fg: "#c2410c" },
        { bg: "#e0f2fe", fg: "#0369a1" },
        { bg: "#f3e8ff", fg: "#7e22ce" },
        { bg: "#cffafe", fg: "#0e7490" },
        { bg: "#fef9c3", fg: "#a16207" },
      ];
      const p = palette[h % palette.length];
      return { background: p.bg, color: p.fg };
    },
    // OTA de origen de la reserva (Booking=1, Airbnb=2…) para pintar su icono.
    otaChannelId(n) {
      const id = n?.id_channel ?? n?.raw?.id_channel ?? null;
      return id === null || id === "" ? null : Number(id);
    },
    // Etiqueta del canal para el tooltip del badge.
    channelLabel(n) {
      const ch = this.notificationChannel(n);
      if (ch === "web") return "Conserje web";
      if (ch === "ota") return this.otaChannelId(n) === 2 ? "Airbnb" : "Booking.com";
      return "WhatsApp";
    },
    // Canal de la conversación (para el badge WhatsApp vs Conserje web vs OTA).
    notificationChannel(n) {
      const ch = String(n?.channel || (n?.raw && n.raw.channel) || "whatsapp").toLowerCase();
      if (ch === "web") return "web";
      if (ch === "ota") return "ota";
      return "whatsapp";
    },
    isNotificationUnread(notification) {
      if (!notification) return false;
      if (notification.read === false) return true;
      if (notification.unread === true) return true;
      if (
        typeof notification.unread_count === "number" &&
        notification.unread_count > 0
      ) {
        return true;
      }
      if (notification.has_new_message === true) return true;
      if (
        notification.raw &&
        typeof notification.raw.unread_count === "number" &&
        notification.raw.unread_count > 0
      ) {
        return true;
      }
      if (notification.raw?.has_new_message === true) return true;
      return false;
    },
    getNotificationUnreadCount(notification) {
      if (!notification) return 0;

      if (
        typeof notification.unread_count === "number" &&
        notification.unread_count > 0
      ) {
        return notification.unread_count;
      }

      if (
        notification.raw &&
        typeof notification.raw.unread_count === "number" &&
        notification.raw.unread_count > 0
      ) {
        return notification.raw.unread_count;
      }

      return this.isNotificationUnread(notification) ? 1 : 0;
    },
    async onClickItem(n) {
      if (
        this.isNotificationUnread(n) &&
        typeof this.selectNotification === "function"
      ) {
        await this.selectNotification(n);
      } else {
        this.$emit("open-conversation", n);
      }

      if (typeof this.toggleBotModal === "function") this.toggleBotModal(false);
    },
    onArchiveClick(notification) {
      this.notificationToArchive = notification;
      this.confirmArchiveVisible = true;
    },
    closeArchiveDialog() {
      this.confirmArchiveVisible = false;
      this.notificationToArchive = null;
      this.archiving = false;
    },
    async confirmArchive() {
      if (!this.notificationToArchive || !this.archiveNotification) return;
      this.archiving = true;
      try {
        await this.archiveNotification(this.notificationToArchive);
      } finally {
        this.closeArchiveDialog();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@500;600;700;800&family=Inter:wght@400;500;600;700;800&display=swap");

$primary: #22c55e;
$ink-900: #0f172a;
$ink-700: #334155;
$ink-600: #475569;
$ink-500: #64748b;
$ink-400: #94a3b8;
$bg-soft: #fcfcfd;

.modal-bot-notifications,
.bot-notifications-content,
.search-input,
.chat-preview,
.empty-state p,
.warning-box,
.hint,
.bot-modal-footer {
  font-family: "DM Sans", sans-serif;
}

.modal-title,
.chat-name,
.empty-state h4,
.modal-header h3 {
  font-family: "DM Sans", sans-serif;
}

.chat-time,
.notif-chip {
  font-family: "DM Sans", sans-serif;
}

:deep(.p-dialog-mask.p-component-overlay) {
  background: rgba(0, 0, 0, 0.5) !important;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
}

:deep(.p-dialog) {
  margin: 0;
  max-height: 100vh !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

:deep(.p-dialog .p-dialog-content) {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.bot-modal-header {
  width: 100%;
  border-bottom: 1px solid #eef2f7;
  background: #ffffff;

  .header-content {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 14px 16px;
  }

  .hdr-icon {
    width: 22px;
    height: 22px;
    color: #3b82f6;
    flex-shrink: 0;
  }

  .title-wrap {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
  }

  .modal-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: $ink-900;
  }

  small {
    color: $ink-500;
    font-size: 0.85rem;
  }
}

.bot-notifications-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: $bg-soft;
}

.search-bar {
  padding: 10px 14px 6px;
  background: $bg-soft;
}

.search-input-wrapper {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: $ink-400;
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 10px 36px 10px 36px;
  border-radius: 999px;
  border: 1px solid #d7e0eb;
  font-size: 0.9rem;
  font-weight: 500;
  color: $ink-700;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: $ink-400;
  }

  &:focus {
    border-color: #9fc2ff;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
  }
}

.clear-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: $ink-400;
  padding: 0 2px;

  &:hover {
    color: $ink-700;
  }
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.5rem 2rem;
  text-align: center;

  .empty-icon {
    margin-bottom: 1.25rem;
    opacity: 0.55;
  }

  h4 {
    color: $ink-900;
    margin-bottom: 0.5rem;
    font-weight: 700;
    font-size: 1.05rem;
  }

  p {
    color: $ink-500;
    margin: 0;
    font-size: 0.92rem;
    line-height: 1.5;
  }
}

.empty-filter {
  padding-top: 2.5rem;
}

/* ── Lista tipo chat: FILAS, no tarjetas (patrón WhatsApp/iMessage) ── */
.notifications-list {
  padding: 2px 0 8px;
  overflow-y: auto;
  flex: 1;
  max-height: 100%;
  background: #ffffff;
  scrollbar-width: thin;
  scrollbar-color: #d7dee8 transparent;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #d7dee8;
    border-radius: 4px;
  }
}

.chat-list-item {
  position: relative;
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 10px 14px;
  background: #ffffff;
  cursor: pointer;
  transition: background 160ms cubic-bezier(0.23, 1, 0.32, 1);
  min-height: 64px;

  /* Divisor fino indentado: empieza tras el avatar, como en una lista de chat */
  &:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 72px;
    right: 14px;
    bottom: 0;
    height: 1px;
    background: #f0f2f6;
  }

  &:hover {
    background: #f4f7fb;
  }
  &:hover .chat-avatar {
    transform: scale(1.05);
  }
  &:active {
    background: #eaeef4;
  }

  /* No leídos: nombre más marcado + preview más oscuro (como WhatsApp) */
  &.unread .chat-name {
    font-weight: 800;
  }
  &.unread .chat-preview {
    color: $ink-700;
    font-weight: 600;
  }
}

.chat-avatar {
    width: 46px;
    height: 46px;
    border-radius: 999px;
    background: #dff3e4;
    color: #0a8f2d;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 0.9rem;
    font-weight: 800;
    letter-spacing: -0.01em;
    position: relative;
    user-select: none;
    transition: transform 200ms cubic-bezier(0.23, 1, 0.32, 1);
}
.chat-channel-badge {
    position: absolute;
    bottom: -2px;
    right: -3px;
    width: 16px;
    height: 16px;
    border-radius: 999px;
    background: #fff;
    border: 1.5px solid #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.chat-channel-badge img {
    width: 14px;
    height: 14px;
    object-fit: contain;
}
.chat-channel-badge--web {
    background: #e7f6ee;
    color: #12964a;
}
/* IconOTA se dibuja a 25px (pensado para las pestañas de la reserva) y ese ancho va
   INLINE con !important en el propio <svg>, así que ninguna regla CSS lo redimensiona.
   Aquí vive en un badge de 16px: lo encajamos ESCALÁNDOLO, que además no lo deforma. */
.chat-channel-badge--ota {
    background: #fff;
}
.chat-channel-badge--ota :deep(.icon-ota) {
    margin-left: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.56);
    transform-origin: center;
}

.chat-main {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.chat-top-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chat-title-block {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 7px;
}

.chat-name {
  margin: 0;
  font-size: 0.94rem;
  line-height: 1.25;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: $ink-900;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

/* Zona hora/archivar (arriba dcha): la hora se desvanece y aparece "archivar" al hover */
.chat-top-actions {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  min-width: 44px;
  height: 20px;
}

.chat-time {
  font-size: 0.72rem;
  color: $ink-400;
  font-weight: 600;
  white-space: nowrap;
  transition: opacity 140ms ease;
}
.chat-list-item:hover .chat-time {
  opacity: 0;
}

.notif-chip {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 6px;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.6;
  max-width: 108px;
  flex-shrink: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chip-purple {
  background: #f2ecfe;
  color: #7c3aed;
}

.chat-bottom-row {
  display: flex;
  align-items: baseline;
  gap: 7px;
  min-width: 0;
}

/* Alojamiento/habitación: contexto, no protagonista. Neutro y en la misma línea
   que el mensaje, para que el nombre del huésped tenga la primera línea entera. */
.chat-room {
  flex-shrink: 0;
  max-width: 44%;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.35;
  color: $ink-400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &::after {
    content: "·";
    margin-left: 7px;
    color: #cbd3e0;
  }
}

.chat-preview {
  margin: 0;
  flex: 1;
  color: $ink-500;
  font-size: 0.85rem;
  line-height: 1.35;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

/* Contador de no leídos. Sin sombra de color: la bandeja mezcla tres canales, así
   que el indicador de estado es uno solo y sobrio, y el canal lo dice el badge del
   avatar. Antes el verde de WhatsApp marcaba también los chats web y de OTA. */
.chat-unread-count {
  flex-shrink: 0;
  min-width: 19px;
  height: 19px;
  padding: 0 6px;
  border-radius: 999px;
  background: #11b14d;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  align-self: center;
}

.chat-unread-dot {
  flex-shrink: 0;
  align-self: center;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #11b14d;
}

/* ── Filtro por canal ─────────────────────────────────────────────
   Aparece bajo el buscador solo cuando conviven varios canales. */
.channel-filters {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.channel-filter {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 11px;
  border: 1px solid #e6eaf1;
  border-radius: 999px;
  background: #ffffff;
  color: $ink-600;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 160ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 160ms cubic-bezier(0.23, 1, 0.32, 1), color 160ms ease;

  &:hover {
    background: #f4f7fb;
    border-color: #d9e0ea;
  }

  &:focus-visible {
    outline: 2px solid #11b14d;
    outline-offset: 2px;
  }

  &.is-active {
    background: #0f1729;
    border-color: #0f1729;
    color: #ffffff;
  }
}

.channel-filter__count {
  font-size: 0.72rem;
  font-weight: 700;
  color: $ink-400;

  .channel-filter.is-active & {
    color: rgba(255, 255, 255, 0.72);
  }
}

/* Recuento de no leídos en la cabecera: informa, no alarma (antes era un badge
   rojo de "peligro" para algo que solo son mensajes pendientes de leer). */
.header-unread {
  flex-shrink: 0;
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  background: #e8f6ee;
  color: #0a7a37;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.3;
}

.header-unread__label {
  font-size: 0.72rem;
  font-weight: 600;
  opacity: 0.85;
}

/* Botón archivar: oculto; aparece al hover ocupando el sitio de la hora */
.archive-btn {
  position: absolute;
  inset: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  color: $ink-400;
  opacity: 0;
  pointer-events: none;
  transition: opacity 140ms ease, color 140ms ease, transform 100ms ease;

  .chat-list-item:hover & {
    opacity: 1;
    pointer-events: auto;
  }
  &:hover {
    color: #ef4444;
  }
  &:active {
    transform: scale(0.92);
  }
}

/* Entrada escalonada de las filas al abrir el drawer (fluida, tipo app de chat) */
@media (prefers-reduced-motion: no-preference) {
  .notifications-list .chat-list-item {
    opacity: 0;
    animation: chat-row-in 0.42s cubic-bezier(0.23, 1, 0.32, 1) both;
  }
  .notifications-list .chat-list-item:nth-child(1) { animation-delay: 0.03s; }
  .notifications-list .chat-list-item:nth-child(2) { animation-delay: 0.07s; }
  .notifications-list .chat-list-item:nth-child(3) { animation-delay: 0.11s; }
  .notifications-list .chat-list-item:nth-child(4) { animation-delay: 0.15s; }
  .notifications-list .chat-list-item:nth-child(5) { animation-delay: 0.19s; }
  .notifications-list .chat-list-item:nth-child(6) { animation-delay: 0.23s; }
  .notifications-list .chat-list-item:nth-child(7) { animation-delay: 0.27s; }
  .notifications-list .chat-list-item:nth-child(n + 8) { animation-delay: 0.3s; }
}

@keyframes chat-row-in {
  from {
    opacity: 0;
    transform: translateY(7px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .chat-list-item,
  .chat-time,
  .archive-btn {
    transition: none;
  }
}

.bot-modal-footer {
  padding: 8px 14px 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}

:deep(.notification-badge) .p-badge {
  background-color: #ef4444 !important;
  color: #fff !important;
  font-size: 0.75rem !important;
  padding: 0.25rem 0.5rem !important;
  border-radius: 12px !important;
  min-width: 20px !important;
  height: 20px !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-weight: 700 !important;
}

:deep(.icon-btn) {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 6px !important;
  border-radius: 999px !important;
}

:deep(.icon-btn.outline) {
  background: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: $ink-600 !important;

  &:hover:not(:disabled) {
    border-color: #cbd5e1 !important;
    background: #f9fafb !important;
  }
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.modal-container {
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.modal-header {
  padding: 22px 26px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
}

.btn-close {
  background: #f3f4f6;
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.btn-close:hover:not(:disabled) {
  background: #ef4444;
  color: white;
}

.modal-body {
  padding: 24px 26px 10px;
  overflow-y: auto;
  flex: 1;
  text-align: left;
}

.modal-footer {
  padding: 18px 26px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  background: #fafafa;
}

.btn-cancel {
  background: white;
  border: 1.5px solid #e5e7eb;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  color: #6b7280;
  font-size: 0.9rem;
}

.btn-save {
  background: #10b981;
  color: white;
  border: none;
  padding: 10px 22px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.btn-danger-strong {
  background: #ef4444 !important;
}

.warning-box {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  color: #7c2d12;
  align-items: flex-start;
  margin-bottom: 14px;
}

.hint {
  font-size: 0.85rem;
  color: #6b7280;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.25s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .chat-list-item {
    padding: 10px 14px;
    min-height: 64px;
    gap: 11px;
  }

  /* Divisor indentado recalculado para el avatar/padding de móvil */
  .chat-list-item:not(:last-child)::after {
    left: 67px;
    right: 14px;
  }

  .chat-avatar {
    width: 42px;
    height: 42px;
    font-size: 0.82rem;
  }

  .chat-name {
    font-size: 0.89rem;
  }

  .chat-preview {
    font-size: 0.82rem;
  }

  .chat-time {
    font-size: 0.68rem;
  }

  .notif-chip {
    max-width: 120px;
    font-size: 0.63rem;
  }

  .modal-container {
    max-width: 100%;
  }
}
</style>
